import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Card } from 'semantic-ui-react';
import { listQboidConfigTables } from '../graphql/queries';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

const PACKED_BOX_PREFIX = 'custrecord_rfs_packed_box';
const PALLET_PREFIX = 'custrecord_rfs_cntr';

// Type is derived from the NetSuite field id used for the length dimension.
function getQboidType(qboid) {
  const lengthField = typeof qboid.LengthField === 'string'
    ? qboid.LengthField.trim().toLowerCase()
    : '';
  if (lengthField.startsWith(PACKED_BOX_PREFIX)) {
    return 'Packed Box';
  }
  if (lengthField.startsWith(PALLET_PREFIX)) {
    return 'Pallet';
  }
  return 'Item';
}

function Qboids() {
  // set state
  const navigate = useNavigate();
  const [customerName, setCustomerName] = useState("");
  const [qboidInfo, setQboidInfo] = useState([]);
  // first data grab
  useEffect(() => {
    async function fetchData() {

      
        let allItems = [];
        let nextToken = null;
      
        do {
          const result = await client.graphql({
            query: listQboidConfigTables,
            variables: {
              limit: 1000,        // max per request (use highest allowed)
              nextToken: nextToken
            }
          });
      
          const data = result.data.listQboidConfigTables;
      
          allItems = [...allItems, ...data.items];
          nextToken = data.nextToken;
      
        } while (nextToken);

      if (allItems) {
        var qboids = allItems.sort(dynamicSort("CustomerName"));
        setQboidInfo(qboids);
      }
    }

    fetchData();
  }, []);

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    }
  }

  const openQboid = (id) => {
    if (id) {
      navigate('/qboid/' + id, { replace: true });
    }
    else {
      navigate('/qboid/', { replace: true });
    }
  }

  const filterQboids = () => {
    if(customerName === '' || customerName === undefined) {
      return qboidInfo;
    } 
    return qboidInfo.filter(q => q.CustomerName !== null && q.CustomerName.toLowerCase().includes(customerName.toLowerCase()));
  }

  return (
    <>
    <div className="field">
      <h1 htmlFor="CustomerName">Customer Name Filter</h1>
      <input type="text"  placeholder="Customer Name" id="CustomerName" value={customerName} onChange={(e) => setCustomerName(e.target.value)} />
    </div>
    <br></br>
    <Card.Group>
      <Card key="newTop" onClick={() => openQboid()}>
        <Card.Content>
          <Card.Header>Add New</Card.Header>
          <button>Edit</button>
        </Card.Content>
      </Card>
      {filterQboids().map(tData => {
        return (
          <Card key={tData.id} onClick={() => openQboid(tData.id)}>
            <Card.Content>
              <Card.Header>{tData.SerialNumber}</Card.Header>
              <div>{tData.CustomerName}</div>
              <div>{tData.ConnectionName}</div>
              <div>License Type: {getQboidType(tData)}</div>
              <button>Edit</button>
            </Card.Content>
          </Card>);
      })}
      <Card key="newBottom" onClick={() => openQboid()}>
        <Card.Content>
          <Card.Header>Add New</Card.Header>
          <button>Edit</button>
        </Card.Content>
      </Card>
    </Card.Group>
    </>
  );
}

export default Qboids